<template>
    <div class="rubric-headings">
        <div class="rubric-show-task">
            <div class="title">
                {{ sectionIn.title }}
            </div>
            <div
                class="weight"
                v-if="showValues">
                <span class="label">Weging:</span>{{ sectionIn.weight }}
            </div>
        </div>

        <div
            class="rubric-row"
            v-for="(row, index) in sectionIn.rubric_rows"
            :key="row.id">
            <div
                class="rubric-show-heading-row"
                :class="`row-heading-${index}`">
                <div class="title">{{ row.title }}</div>
                <div
                    class="weight"
                    v-if="showValues">
                    <span class="label">{{ $t('rubrics.weight') }}</span
                    >{{ row.weight }}
                </div>
            </div>
            <div
                class="rubric-show-selected-row"
                :class="showOtherResults && row.hasAnswerForOtherUsers($authUser.id) ? 'show' : ''"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-rubric-form-row-headings-component',
    props: {
        sectionIn: Object,
        showValues: Number,
        showOtherResults: Boolean,
    },
};
</script>

<style scoped lang="scss">
.rubric-headings {
    border-left: 1px solid $border-color;
    width: 210px;
}

.rubric-show-task {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    min-height: 50px;
    background-color: $secondary-background-color;
    padding: map-get($grid-gutter-spacing, 'eight');
    border-bottom: 1px solid $border-color;
}

.rubric-show-task .title {
    text-align: center;
    font-size: $default-font-size;
    font-weight: $font-weight-medium;
    margin-bottom: $paragraph-margin-bottom;
}

.rubric-show-task .weight {
    font-size: $default-font-size;
    font-weight: $font-weight-bold;
    color: $body-color;
}

.rubric-show-task .label {
    margin-right: map-get($grid-gutter-spacing, 'five');
}

.rubric-show-heading-row {
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: map-get($grid-gutter-spacing, 'eight');
    background-color: $secondary-background-color;
    border-bottom: 1px solid $border-color;
    height: 117px;
}

.rubric-show-heading-row .title {
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    font-size: $default-font-size;
    font-weight: $font-weight-medium;
    margin-bottom: map-get($grid-gutter-spacing, 'five');
}

.rubric-show-heading-row .weight {
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    font-size: $default-font-size;
    font-weight: $font-weight-medium;
}

.rubric-show-heading-row .weight .label {
    margin-right: map-get($grid-gutter-spacing, 'five');
}

.rubric-show-selected-row {
    display: none;
}

.rubric-show-selected-row.show {
    display: flex;
    justify-content: flex-end;
    padding: map-get($grid-gutter-spacing, 'eight') map-get($grid-gutter-spacing, 'five')
        map-get($grid-gutter-spacing, 'eight') map-get($grid-gutter-spacing, 'eight');
    border-right: 1px solid $border-color;
    border-bottom: 1px solid $border-color;
    min-height: 45px;
}
</style>
